import { authorize, putRequest } from '../../../utils/http';
import { AWS_API_URL } from '../../../global/environment';

export async function sendPinForPairingAPI(user) {
  const url = `${AWS_API_URL}/2n/users/${user.Id}/mobile-key/send-pin`;

  return putRequest(url, {
    data: {
      email: user.Account.Email,
    },
  }, await authorize());
}
